const de = {
    "chess:q": "D",
    "chess:k": "K",
    "chess:r": "T",
    "chess:b": "L",
    "chess:n": "S",
    "chess:Q": "D",
    "chess:K": "K",
    "chess:R": "T",
    "chess:B": "L",
    "chess:N": "S",
    "buttons:flipper": "Tausche die Seiten",
    "buttons:first": "Gehe zum ersten Zug",
    "buttons:prev": "Gehe einen Zug zurück",
    "buttons:next": "Nächster Zug",
    "buttons:play": "Spiele alle Züge",
    "buttons:last": "Gehe ans Ende des Spiels",
    "buttons:deleteVar": "Lösche Variante",
    "buttons:promoteVar": "Werte Variante auf",
    "buttons:deleteMoves": "Lösche die restlichen Züge von hier",
    "buttons:nags": "NAGs Menü",
    "buttons:pgn": "Zeige die PGN Notation an",
    "buttons:hidePGN": "Ausblenden des angezeigten PGN",
    "buttons:getHint": "Gib einen Hinweis",
    "buttons:makeMove": "Zeige den nächsten Zug",
    "buttons:showSolution": "Zeige die ganze Lösung",
    "nag:$1": "Starker Zug",
    "nag:$1_menu": "Guter Zug",
    "nag:$2": "Ein Fehler",
    "nag:$2_menu": "Fehler",
    "nag:$3": "Sehr starker Zug",
    "nag:$3_menu": "Sehr guter Zug",
    "nag:$4": "Ein grober Fehler",
    "nag:$4_menu": "Grober Fehler",
    "nag:$5": "Interessanter Zug",
    "nag:$5_menu": "Interessanter Zug",
    "nag:$6": "Zweifelhafter Zug",
    "nag:$6_menu": "Zweifelhafter Zug",
    "nag:$7": "Erzwungener Zug",
    "nag:$7_menu": "Erzwungener Zug",
    "nag:$8": "Einziger Zug",
    "nag:$8_menu": "Einziger Zug",
    "nag:$9": "Schlechtester Zug",
    "nag:$10": "Ausgeglichene Stellung",
    "nag:$10_menu": "Ausgeglichene Stellung",
    "nag:$11": "Ausgeglichene ruhige Stellung",
    "nag:$12": "Ausgeglichene aktive Stellung",
    "nag:$13": "Unklar",
    "nag:$13_menu": "Unklar",
    "nag:$14": "Weiß steht etwas besser",
    "nag:$14_menu": "Weiß steht etwas besser",
    "nag:$15": "Schwarz steht etwas besser",
    "nag:$15_menu": "Schwarz steht etwas besser",
    "nag:$16": "Weiß steht besser",
    "nag:$16_menu": "Weiß steht besser",
    "nag:$17": "Schwarz steht besser",
    "nag:$17_menu": "Schwarz steht besser",
    "nag:$18": "Weiß hat entscheidenden Vorteil",
    "nag:$18_menu": "Weiß gewinnt",
    "nag:$19": "Schwarz hat entscheidenden Vorteil",
    "nag:$19_menu": "Schwarz gewinnt",
    "nag:$20": "Weiß steht auf Gewinn.",
    "nag:$21": "Schwarz steht auf Gewinn.",
    "nag:$22": "Zugzwang Weiß",
    "nag:$22_menu": "Zugzwang",
    "nag:$23": "Zugzwang Schwarz",
    "nag:$24": "Weiß hat Raumvorteil",
    "nag:$24_menu": "Raumvorteil",
    "nag:$25": "Schwarz hat Raumvorteil",
    "nag:$26": "Weiß hat großen Raumvorteil",
    "nag:$27": "Schwarz hat großen Raumvorteil",
    "nag:$28": "Weiß hat entscheidenden Raumvorteil",
    "nag:$29": "Schwarz hat entscheidenden Raumvorteil",
    "nag:$30": "Weiß hat leichten Entwicklungsvorteil",
    "nag:$31": "Schwarz hat leichten Entwicklungsvorteil",
    "nag:$32": "Weiß hat moderaten Entwicklungsvorteil",
    "nag:$32_menu": "Entwicklungsvorteil",
    "nag:$33": "Schwarz hat moderaten Entwicklungsvorteil",
    "nag:$34": "Weiß hat entscheidenden Entwiclungsvorteil",
    "nag:$35": "Schwarz hat entscheidenden Entwiclungsvorteil",
    "nag:$36": "Weiß hat die Initiative",
    "nag:$36_menu": "Initiative",
    "nag:$37": "Schwarz hat die Initiative",
    "nag:$38": "Weiß hat entscheidende Initiative",
    "nag:$39": "Schwarz hat entscheidende Initiative",
    "nag:$40": "Weiß hat Angriff",
    "nag:$40_menu": "Angriffsvorteil",
    "nag:$41": "Schwarz hat Angriff",
    "nag:$42": "Weiß hat ungenügende Kompensation für das verlorene Material",
    "nag:$43": "Schwarz hat ungenügende Kompensation für das verlorene Material",
    "nag:$44": "Weiß hat genügende Kompensation für das verlorene Material",
    "nag:$44_menu": "Mit Kompensation",
    "nag:$45": "Schwarz hat genügende Kompensation für das verlorene Material",
    "nag:$46": "Weiß hat mehr als genügende Kompensation für das verlorene Material",
    "nag:$47": "Schwarz hat mehr als genügende Kompensation für das verlorene Material",
    "nag:$48": "Weiß hat einen leichten Kontrollvorteil im Zentrum",
    "nag:$49": "Schwarz hat einen leichten Kontrollvorteil im Zentrum",
    "nag:$50": "Weiß hat einen mäßigen Kontrollvorteil im Zentrum",
    "nag:$51": "Schwarz hat einen mäßigen Kontrollvorteil im Zentrum",
    "nag:$52": "Weiß hat einen entscheidenden Kontrollvorteil im Zentrum",
    "nag:$53": "Schwarz hat einen entscheidenden Kontrollvorteil im Zentrum",
    "nag:$54": "Weiß hat einen leichten Kontrollvorteil am Königsflügel",
    "nag:$55": "Schwarz hat einen leichten Kontrollvorteil am Königsflügel",
    "nag:$56": "Weiß hat einen moderaten Kontrollvorteil am Königsflügel",
    "nag:$57": "Schwarz hat einen moderaten Kontrollvorteil am Königsflügel",
    "nag:$58": "Weiß hat einen entscheidenden Kontrollvorteil am Königsflügel",
    "nag:$59": "Schwarz hat einen entscheidenden Kontrollvorteil am Königsflügel",
    "nag:$60": "Weiß hat einen leichten Kontrollvorteil am Damenflügel",
    "nag:$61": "Schwarz hat einen leichten Kontrollvorteil am Damenflügel",
    "nag:$62": "Weiß hat einen moderaten Kontrollvorteil am Damenflügel",
    "nag:$63": "Schwarz hat einen moderaten Kontrollvorteil am Damenflügel",
    "nag:$64": "Weiß hat einen entscheidenden Kontrollvorteil am Damenflügel",
    "nag:$65": "Schwarz hat einen entscheidenden Kontrollvorteil am Damenflügel",
    "nag:$66": "Weiß hat eine verwundbare erste Reihe",
    "nag:$67": "Schwarz hat eine verwundbare erste Reihe",
    "nag:$68": "Weiß hat eine gut geschützte erste Reihe",
    "nag:$69": "Schwarz hat eine gut geschützte erste Reihe",
    "nag:$70": "Weiß hat einen schlecht geschützten König",
    "nag:$71": "Schwarz hat einen schlecht geschützten König",
    "nag:$72": "Weiß hat einen gut geschützten König",
    "nag:$73": "Schwarz hat einen gut geschützten König",
    "nag:$74": "Weiß hat einen schlecht platzierten König",
    "nag:$75": "Schwarz hat einen schlecht platzierten König",
    "nag:$76": "Weiß hat einen gut platzierten König",
    "nag:$77": "Schwarz hat einen gut platzierten König",
    "nag:$78": "Weiß hat eine sehr schwache Bauernstruktur",
    "nag:$79": "Schwarz hat eine sehr schwache Bauernstruktur",
    "nag:$80": "Weiß hat eine mäßig schwache Bauernstruktur",
    "nag:$81": "Schwarz hat eine mäßig schwache Bauernstruktur",
    "nag:$82": "Weiß hat eine mäßig starke Bauernstruktur",
    "nag:$83": "Schwarz hat eine mäßig starke Bauernstruktur",
    "nag:$84": "Weiß hat eine sehr starke Bauernstruktur",
    "nag:$85": "Schwarz hat eine sehr starke Bauernstruktur",
    "nag:$86": "Weiß hat einen schlecht platzierten Springer",
    "nag:$87": "Schwarz hat einen schlecht platzierten Springer",
    "nag:$88": "Weiß hat eine gute Springerstellung",
    "nag:$89": "Schwarz hat eine gute Springerstellung",
    "nag:$90": "Weiß hat schlechte Läuferstellung",
    "nag:$91": "Schwarz hat schlechte Läuferstellung",
    "nag:$92": "Weiß hat eine gute Läuferstellung",
    "nag:$93": "Schwarz hat eine gute Läuferstellung",
    "nag:$94": "Weiß hat einen schlecht platzierten Turm",
    "nag:$95": "Schwarz hat einen schlecht platzierten Turm",
    "nag:$96": "Weiß hat eine gute Turmstellung",
    "nag:$97": "Schwarz hat eine gute Turmstellung",
    "nag:$98": "Weiß hat eine schlechte Stellung der Königin",
    "nag:$99": "Schwarz hat eine schlechte Stellung der Königin",
    "nag:$100": "Weiß hat eine gute Stellung der Königin",
    "nag:$101": "Schwarz hat eine gute Stellung der Königin",
    "nag:$102": "Weiß hat schlechte Figurenkoordination",
    "nag:$103": "Schwarz hat schlechte Figurenkoordination",
    "nag:$104": "Weiß hat eine gute Figurenkoordination",
    "nag:$105": "Schwarz hat eine gute Figurenkoordination",
    "nag:$106": "Weiß hat die Eröffnung sehr schlecht gespielt",
    "nag:$107": "Schwarz hat die Eröffnung sehr schlecht gespielt",
    "nag:$108": "Weiß hat die Eröffnung schlecht gespielt",
    "nag:$109": "Schwarz hat die Eröffnung schlecht gespielt",
    "nag:$110": "Weiß hat die Eröffnung gut gespielt",
    "nag:$111": "Schwarz hat die Eröffnung gut gespielt",
    "nag:$112": "Weiß hat die Eröffnung sehr gut gespielt",
    "nag:$113": "Schwarz hat die Eröffnung sehr gut gespielt",
    "nag:$114": "Weiß hat das Mittelspiel sehr schlecht gespielt",
    "nag:$115": "Schwarz hat das Mittelspiel sehr schlecht gespielt",
    "nag:$116": "Weiß hat das Mittelspiel schlecht gespielt",
    "nag:$117": "Schwarz hat das Mittelspiel schlecht gespielt",
    "nag:$118": "Weiß hat das Mittelspiel gut gespielt",
    "nag:$119": "Schwarz hat das Mittelspiel gut gespielt",
    "nag:$120": "Weiß hat das Mittelspiel sehr gut gespielt",
    "nag:$121": "Schwarz hat das Mittelspiel sehr gut gespielt",
    "nag:$122": "Weiß hat das Endspiel sehr schlecht gespielt",
    "nag:$123": "Schwarz hat das Endspiel sehr schlecht gespielt",
    "nag:$124": "Weiß hat das Endspiel schlecht gespielt",
    "nag:$125": "Schwarz hat das Endspiel schlecht gespielt",
    "nag:$126": "Weiß hat das Endspiel gut gespielt",
    "nag:$127": "Schwarz hat das Endspiel gut gespielt",
    "nag:$128": "Weiß hat das Endspiel sehr gut gespielt",
    "nag:$129": "Schwarz hat das Endspiel sehr gut gespielt",
    "nag:$130": "Weiß hat leichtes Gegenspiel",
    "nag:$131": "Schwarz hat leichtes Gegenspiel",
    "nag:$132": "Weiß hat mäßiges Gegenspiel",
    "nag:$132_menu": "Gegenspiel",
    "nag:$133": "Schwarz hat mäßiges Gegenspiel",
    "nag:$134": "Weiß hat entscheidendes Gegenspiel",
    "nag:$135": "Schwarz hat entscheidendes Gegenspiel",
    "nag:$136": "Weiß hat mäßigen Zeitkontrolldruck",
    "nag:$136_menu": "Zeitnot",
    "nag:$137": "Schwarz hat mäßigen Zeitkontrolldruck",
    "nag:$138": "Weiß hat starken Zeitkontrolldruck",
    "nag:$139": "Schwarz hat starken Zeitkontrolldruck",
    "nag:$140": "Mit der Idee",
    "nag:$140_menu": "Mit der Idee",
    "nag:$141": "Gezielt gegen",
    "nag:$142": "Besser ist",
    "nag:$143": "Schlechter ist",
    "nag:$144": "Gleich ist",
    "nag:$145": "Redaktioneller Kommentar",
    "nag:$146": "Neuheit",
    "nag:$146_menu": "Neuheit",
    "nag:$220": "Diagramm (Perspektive Weiß)",
    "nag:$221": "Diagramm (Perspektive Schwarz)",
    "nag:$238": "Platzvorteil",
    "nag:$239": "Reihe",
    "nag:$240": "Diagonale",
    "nag:$241": "Zentrum",
    "nag:$242": "Königsseite",
    "nag:$243": "Damenseite",
    "nag:$244": "Schwacher Punkt",
    "nag:$245": "Enspiel",
    "nag:$246": "Läuferpaar",
    "nag:$247": "Verschiedenfarbige Läufer",
    "nag:$248": "Gleichfarbige Läufer",
    "nag:$249": "Verbundene Bauern",
    "nag:$250": "Isolierte Bauern",
    "nag:$251": "Doppelbauern",
    "nag:$252": "Freibauern",
    "nag:$253": "Bauernmehrheit",
    "nag:$254": "Mit",
    "nag:$255": "Ohne",
};
export default de;
